import React from 'react'
import SmartLink from '../SmartLink'
import Text from '../Text'
import styles from './styles.module.css'
import { useServed } from '../../store/regionStore'

// Buy-block notice for served=false visitors (item 4). A served=false visitor
// still sees the /world catalog, but the add-to-cart / checkout action is
// replaced with this clear "we don't ship to your location" notice. Reads the
// per-user `served` flag (derived from the visitor's shipping country + the
// backend country map) and renders nothing for served visitors, so it is inert
// on every us/eu/au/world page for everyone we can ship to.
//
// Per-user + client-only: `served` is overlaid AFTER mount, so this never
// affects the SSR HTML / hydration (the SSR HTML stays identical for every
// visitor and shared-cacheable).
function CantShipNotice() {
  const served = useServed()
  if (served) {
    return null
  }
  return (
    <div className={styles.wrapper} role="alert" data-testid="cant-ship-notice">
      <Text type="heading-7">We don&apos;t ship to your location</Text>
      <Text type="medium">
        Unfortunately we can&apos;t currently ship orders to your country, so checkout is
        unavailable. You can still browse the full catalog. If you think this is a
        mistake or want to discuss options, please <SmartLink href="/contact">contact support</SmartLink>.
      </Text>
    </div>
  )
}

export default CantShipNotice
